import type { NamespaceCatalog } from '@/i18n/ns';

const copy: NamespaceCatalog<'undo' | 'undone'> = {
  en: { undo: 'Undo', undone: 'Undone.' },
  bg: { undo: 'Отмяна', undone: 'Отменено.' },
  hr: { undo: 'Poništi', undone: 'Poništeno.' },
  cs: { undo: 'Vrátit zpět', undone: 'Vráceno zpět.' },
  da: { undo: 'Fortryd', undone: 'Fortrudt.' },
  nl: { undo: 'Ongedaan maken', undone: 'Ongedaan gemaakt.' },
  et: { undo: 'Võta tagasi', undone: 'Tagasi võetud.' },
  fi: { undo: 'Kumoa', undone: 'Kumottu.' },
  fr: { undo: 'Annuler', undone: 'Annulé.' },
  de: { undo: 'Rückgängig', undone: 'Rückgängig gemacht.' },
  el: { undo: 'Αναίρεση', undone: 'Αναιρέθηκε.' },
  hu: { undo: 'Visszavonás', undone: 'Visszavonva.' },
  ga: { undo: 'Cealaigh', undone: 'Cealaithe.' },
  it: { undo: 'Annulla', undone: 'Annullato.' },
  lv: { undo: 'Atsaukt', undone: 'Atsaukts.' },
  lt: { undo: 'Anuliuoti', undone: 'Anuliuota.' },
  mt: { undo: 'Ħassar il-bidla', undone: 'Il-bidla tħassret.' },
  pl: { undo: 'Cofnij', undone: 'Cofnięto.' },
  pt: { undo: 'Anular', undone: 'Anulado.' },
  ro: { undo: 'Anulează', undone: 'Anulat.' },
  sk: { undo: 'Vrátiť späť', undone: 'Vrátené späť.' },
  sl: { undo: 'Razveljavi', undone: 'Razveljavljeno.' },
  es: { undo: 'Deshacer', undone: 'Deshecho.' },
  sv: { undo: 'Ångra', undone: 'Ångrat.' },
};
export default copy;
